export const sizes = {
  container: 900,
  sidebar: '200px',
  sidebarSkinny: '50%',
  contentMaxWidth: '900px',
}
